<template>
  <section class="container">
    <div class="col-md-8 mx-auto">
      <h2>Cookie Policy</h2>
      <p><strong>Last revision: 2024-12-12</strong></p>

      <h2>What are cookies?</h2>
      <p>
        Cookies and similar technologies are very small text documents or pieces of code that often
        contain a unique identification code. When you visit a website or use a mobile application,
        a computer asks your computer or mobile device for permission to save this file on your
        computer or mobile device and gain access to information. Information collected through
        cookies and similar technologies may include the date and time of the visit and how you use
        a particular website or mobile application.
      </p>

      <h2>Why do we use cookies?</h2>
      <p>
        Cookies ensure that some data and settings are kept, and the website keeps running smoothly.
        The cookies also ensure that we can see how our website is used and how we can improve it.
        Furthermore, depending on your preferences our own cookies may be used to present you with
        targeted advertisements that match your personal interests.
      </p>

      <h2>What type of cookies do we use?</h2>
      <h3>Necessary cookies</h3>
      <p>
        These cookies are necessary for the website to function properly. Some of the following
        actions can be performed by using these cookies:
      </p>
      <ul>
        <li>Store settings and entries</li>
        <li>Save your cookie preferences for this website</li>
        <li>Saving language preferences</li>
        <li>Log in to our portal. We need to check whether you are logged in.</li>
      </ul>

      <h3>Performance cookies</h3>
      <p>
        These cookies are used to gather statistical information about the use of our website, also
        called analytics cookies. We use this data for performance and website optimization.
      </p>

      <h3>Functional cookies</h3>
      <p>
        These cookies enable more functionality for our website visitors. These cookies can be set
        by our external service providers or our own website. The following functionalities may or
        may not be activated when you accept this category:
      </p>
      <ul>
        <li>Live chat services</li>
        <li>Watch online videos</li>
        <li>Social media sharing buttons</li>
        <li>Login to our website with social media</li>
      </ul>

      <h3>Advertising / tracking cookies</h3>
      <p>
        These cookies are set by external advertising partners and are used for profiling and
        tracking data across multiple websites. If you accept these cookies, we may show our
        advertisements on other websites based on your user profile and preferences.
      </p>
      <p>
        These cookies also save data about how many visitors have seen or clicked on our
        advertisements in order to optimize advertising campaigns.
      </p>

      <h3>Unclassified</h3>
      <p>
        These cookies are still in the classification process. They will show up in one on the
        following categories; Necessary, Performance, Functional or Advertising.
      </p>

      <h2>How can I switch off or remove cookies?</h2>
      <p>
        You can choose to opt out of all but the necessary cookies. In the settings of the browser,
        you can change the settings to ensure that cookies will be blocked. Most browsers provide
        you with an explanation on how to do this in the so-called ‘help-function’. However, if you
        block the cookies, it is possible that you will not be able to enjoy all the technical
        features our website has to offer, and it may negatively affect your user experience.
      </p>
    </div>
  </section>
</template>
<script>
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title: 'Cookie Policy | Jobshark',
};
</script>
<style lang="scss" scoped>
.container {
  padding: 80px 0;
}
</style>
